export default __webpack_public_path__ + "static/media/big-blue-arrow.ba9115d1.png";